import { Skeleton } from '@mui/material';
import React from 'react';

export default function Sceletons() {
  return (
    <React.Fragment>
      {[...Array(3).keys()].map((i) => (
        <Skeleton key={i} variant='rectangular' sx={{ width: '100%', height: '5rem', borderRadius: '0.5rem' }} />
      ))}
    </React.Fragment>
  );
}
